'use client'

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { UserButton } from "@clerk/nextjs";
import { LayoutDashboard, Download } from "lucide-react";
import posthog from "posthog-js";

export function HeaderActions({ isAuthenticated }: { isAuthenticated: boolean }) {
    if (isAuthenticated) {
        return (
            <>
                <Link href="/subscription">
                    <Button variant="ghost" className="text-slate-700 hover:text-indigo-600 font-medium">
                        <LayoutDashboard className="w-4 h-4 mr-2" />
                        Dashboard
                    </Button>
                </Link>
                <div className="pl-2 border-l border-slate-200">
                    <UserButton afterSignOutUrl="/" />
                </div>
            </>
        );
    }

    return (
        <>
            <Link
                href="/sign-in"
                className="text-sm font-semibold text-slate-700 hover:text-slate-900 transition-colors"
                onClick={() => posthog.capture('click_login', { location: 'header' })}
            >
                Accedi
            </Link>
            <Link
                href="/checklist-sopravvissuto"
                onClick={() => posthog.capture('click_checklist_lead', {
                    location: 'header',
                    value_prop: '12 controlli settimanali per non perdere provvigioni'
                })}
            >
                <Button variant="outline" className="text-honey-700 border-honey-300 hover:bg-honey-50 hover:text-honey-800 font-semibold">
                    <Download className="w-4 h-4 mr-2" />
                    Checklist Gratis
                </Button>
            </Link>
            <Link
                href="/cta"
                onClick={() => posthog.capture('click_prova_gratis', { location: 'header' })}
            >
                <Button className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold shadow-sm">
                    Prova Gratis
                </Button>
            </Link>
        </>
    );
}
